import { render, staticRenderFns } from "./SuccessResetPass.vue?vue&type=template&id=31828472&scoped=true&"
import script from "./SuccessResetPass.vue?vue&type=script&lang=js&"
export * from "./SuccessResetPass.vue?vue&type=script&lang=js&"
import style0 from "./SuccessResetPass.vue?vue&type=style&index=0&id=31828472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31828472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCard,VCol,VContainer,VRow})
